import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

* {
  padding: 0;
  box-sizing: border-box;
  margin: 0;
}

* {
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.5) transparent;
}

*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: rgba(118, 118, 118, 0.5);
  border-radius: 60px;
  border: transparent;
}




html,body {
    color: white;
    overflow-x: hidden;
    position: relative;
    font-family: 'Roboto', sans-serif;
  }


button, a {
  cursor: pointer;
}

.container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;



  
  @media (min-width: 1600px) {
    margin: auto;
    width: 100rem;
  }
}


.shell {
  margin: 0rem 10rem;
  position: relative;


  @media (max-width: 1300px) {
    margin: 0rem 5rem;
  }

  @media (max-width: 1024px) {
    margin: 0rem 3rem;
  }

  @media (max-width: 600px) {
    margin: 0rem 2rem;
  }
}

.container-flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}





.bg-overlay {
  object-fit: cover;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
}




 
`;

export default GlobalStyle;
